import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RankLabels } from '@digital-twins/slide-schemas/generated/plot-types'

/**
 * The `ranking-bars` chrome in the viewer's UI language (plots plan I, owner
 * decision 5), keyed by the plot's label keys. Summary cards and stored
 * payloads carry no chrome in the viewer's language, so the app supplies the
 * same keys `deck_labels.py` holds for the deck, from its own translations.
 * The `{rank}`, `{low}`, `{high}`, `{shown}` and `{total}` placeholders are
 * filled by the plot with the figures Python stamped.
 */
export function useRankingBarsLabels(): RankLabels {
  const { t } = useTranslation('app')

  return useMemo(
    () => ({
      plot_rank_n: t('studyReport.plotRankN'),
      too_close_to_call: t('studyReport.tooCloseToCall'),
      plot_score_range: t('studyReport.plotScoreRange'),
      n_of_total_shown: t('studyReport.plotNOfTotalShown'),
    }),
    [t],
  )
}
